import { render, staticRenderFns } from "./SideComponent.vue?vue&type=template&id=41fd6113&scoped=true&"
import script from "./SideComponent.vue?vue&type=script&lang=js&"
export * from "./SideComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd6113",
  null
  
)

export default component.exports